import { render, staticRenderFns } from "./OfferTemplateEdit.vue?vue&type=template&id=48d06345&"
import script from "./OfferTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./OfferTemplateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/michaelzickert/Development/capture-studio/capture-studio-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48d06345')) {
      api.createRecord('48d06345', component.options)
    } else {
      api.reload('48d06345', component.options)
    }
    module.hot.accept("./OfferTemplateEdit.vue?vue&type=template&id=48d06345&", function () {
      api.rerender('48d06345', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/OfferTemplateEdit.vue"
export default component.exports